import { SELECIONAR_EMISSAO_MDFE } from '../types'

export default function selecionarEmissaoMdfe(emissaoMdfe) {
  return {
    type: SELECIONAR_EMISSAO_MDFE,
    payload: emissaoMdfe
  }
}
